var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinusSquare = function SvgMinusSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.273 2.047a2.68 2.68 0 0 1 2.678 2.678V19.27c0 1.48-1.199 2.678-2.678 2.678H4.728A2.68 2.68 0 0 1 2.05 19.27V4.725a2.68 2.68 0 0 1 2.678-2.678zm-14.545 1.2c-.817 0-1.479.661-1.479 1.478V19.27a1.48 1.48 0 0 0 1.479 1.479h14.545a1.48 1.48 0 0 0 1.479-1.479V4.725a1.48 1.48 0 0 0-1.479-1.479zm11.428 8.25a.5.5 0 0 1 0 1H7.844a.5.5 0 0 1 0-1z"
  })));
};
export default SvgMinusSquare;